<template>
    <div id="Section-07" class="section-07 wsl-flex-center-ng">
        <div class="container">
            <div class="wsl-show-sm wsl-show-xs"
                 :style="{backgroundImage: `url(${s07Bg1}`}"
                 style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;">

                <div class="cb-bg-blue block-header wsl-p-y-10">
                    <div class="wsl-flex-middle-ng">
                        <div class="Oswald-Regular wsl-bg-white cb-cyan t24 wsl-flex-center-middle-ng wsl-p-x-6">07</div>
                        <div class="Oswald-Regular cb-cyan t24 wsl-m-l-15">Дополнительные сервисы</div>
                    </div>
                </div>

                <div class="wsl-show-sm wsl-show-xs wsl-p-a-15" style="
                    background-color: #fff;">
                    <div class="wsl-flex-middle-ng">
                        <div class="wsl-text-left wsl-p-x-30" style="line-height: 1.2;">
                            <div>
                                <span class="Oswald-Light cb-cyan t36">Настоящий сервис – </span>
                                <span class="Oswald-Light cb-blue t36">в деталях</span><br>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wsl-p-y-60 padding-sm-xs">
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Автоматическое формирование пакета документов для туриста
                        (договор, лист бронирования, информация о туроператоре) из каждой заявки.
                        Документы разработаны нашим юридическим отделом в полном соответствии с
                        требованиями законодательства РФ
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Поддержка нашей юридической службы в спорах с поставщиками услуг
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Регулярные обучающие мероприятия
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Единая бонусная программа для всех туроператоров
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Мини CRM система для ведения истории заявки
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Адаптированная для работы с мобильных устройств система
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white wsl-text-center" style="line-height: 1.3">
                        <span class="cb-blue">ЗАРЕГИСТРИРУЙТЕСЬ СЕЙЧАС И ПОЛУЧИТЕ</span><br>
                        ПОЛНЫЙ <span class="cb-blue">ДОСТУП К НАШИМ УСЛУГАМ</span>
                    </div>
                    <div class="wsl-m-35 wsl-m-t-50 wsl-text-center">
                        <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>
            </div>

            <div class="wsl-relative wsl-show-md"
                 :style="{backgroundImage: `url(${s07Bg1}`}"
                 style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;">

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s07Bg2}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    bottom: 0; right: 0; width: 33.34%; height: 100%;">
                    <div class="wsl-w-100 wsl-h-100 wsl-relative">
                        <div class="wsl-abs wsl-abs-top wsl-flex-middle-ng" style="top: 5%; left: 10%;">
                            <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6">07
                            </div>
                            <div class="Oswald-Regular cb-cyan t30 wsl-m-l-15">Дополнительные сервисы</div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s07Bg3}`}"
                     style="
                    background-color: #fff;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: left top;
                    top: 25%; right: 6.23%; width: 31.36%; height: 61.76%;">
                    <div class="wsl-flex-middle-ng wsl-h-100">
                        <div class="wsl-text-left wsl-p-r-10" style="line-height: 1.2; padding-left: 48px;">
                            <div>
                                <span class="Oswald-Light cb-cyan t36">Настоящий сервис –</span><br>
                                <span class="Oswald-Light cb-blue t36">в деталях</span><br>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wsl-p-y-60" style="padding-left: 5%; padding-right: 40%;">
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Автоматическое формирование пакета документов для туриста
                        (договор, лист бронирования, информация о туроператоре) из каждой заявки.
                        Документы разработаны нашим юридическим отделом в полном соответствии с
                        требованиями законодательства РФ
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Поддержка нашей юридической службы в спорах с поставщиками услуг
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Регулярные обучающие мероприятия
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Единая бонусная программа для всех туроператоров
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Мини CRM система для ведения истории заявки
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white">
                        Адаптированная для работы с мобильных устройств система
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-20 cb-white wsl-text-center" style="line-height: 1.3">
                        <span class="cb-blue">ЗАРЕГИСТРИРУЙТЕСЬ СЕЙЧАС И ПОЛУЧИТЕ</span><br>
                        ПОЛНЫЙ <span class="cb-blue">ДОСТУП К НАШИМ УСЛУГАМ</span>
                    </div>
                    <div class="wsl-m-35 wsl-m-t-50 wsl-text-center">
                        <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>
            </div>

            <div class="wsl-w-100 wsl-h-100 wsl-relative wsl-hide-md wsl-hide-sm wsl-hide-xs">
                <img alt="" class="wsl-w-100 wsl-h-100"
                     src="../assets/img/s07-bg1.jpg">

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s07Bg2}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    bottom: 0; right: 0; width: 33.34%; height: 100%;">
                    <div class="wsl-w-100 wsl-h-100 wsl-relative">
                        <div class="wsl-abs wsl-abs-top wsl-flex-middle-ng" style="top: 5%; left: 10%;">
                            <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6">07
                            </div>
                            <div class="Oswald-Regular cb-cyan t30 wsl-m-l-15">Дополнительные сервисы</div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs"
                     :style="{backgroundImage: `url(${s07Bg3}`}"
                     style="
                    background-color: #fff;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: left top;
                    top: 20.63%; right: 6.23%; width: 31.36%; height: 61.76%;">
                    <div class="wsl-flex-middle-ng wsl-h-100">
                        <div class="wsl-text-left wsl-p-r-10" style="line-height: 1.2; padding-left: 48px;">
                            <div>
                                <span class="Oswald-Light cb-cyan t48">Настоящий сервис –</span><br>
                                <span class="Oswald-Light cb-blue t48">в деталях</span><br>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wsl-abs" style="top: 5%; padding-left: 6.45%; padding-right: 40%; line-height: 1;">
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Автоматическое формирование пакета документов для туриста
                        (договор, лист бронирования, информация о туроператоре) из каждой заявки.
                        Документы разработаны нашим юридическим отделом в полном соответствии с
                        требованиями законодательства РФ
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Поддержка нашей юридической службы в спорах с поставщиками услуг
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Регулярные обучающие мероприятия
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Единая бонусная программа для всех туроператоров
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Мини CRM система для ведения истории заявки
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white">
                        Адаптированная для работы с мобильных устройств система
                    </div>
                    <div class="Oswald-Light t24 wsl-m-y-40 cb-white wsl-text-center" style="line-height: 1.3">
                        <span class="cb-blue">ЗАРЕГИСТРИРУЙТЕСЬ СЕЙЧАС И ПОЛУЧИТЕ</span><br>
                        ПОЛНЫЙ <span class="cb-blue">ДОСТУП К НАШИМ УСЛУГАМ</span>
                    </div>
                    <div class="wsl-m-35 wsl-m-b-30 wsl-text-center">
                        <a class="cb-btn-blue wsl-inline-block z-depth-3" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Section-07',
  props: {
    s07Bg1: String,
    s07Bg2: String,
    s07Bg3: String
  }
}
</script>

<style scoped>

</style>
